module.exports = __webpack_public_path__ + "img/zhangfeng-portrait.a5edf123.png";